// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/forester-film-edits-44.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .fdvC6wJWb7N6Pdr98BXA {
    position: relative;
    clip-path: polygon(65% 0, 100% 3%, 100% 100%, 34% 95%, 0 100%, 0 0, 36% 6%);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-attachment: scroll;
    background-size: cover;
    background-position: center;
    font-family: "Poppins", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 5rem;
    overflow: hidden;
  }
  .oWon0UkDx0_lYPNnYvv2 {
    clip-path: polygon(65% 0, 100% 3%, 100% 100%, 34% 95%, 0 100%, 0 0, 36% 6%);
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: ghostwhite;
    position: relative;
    margin: 5rem;
    padding: 10rem 2rem;
    z-index: 2;
  }
  .oWon0UkDx0_lYPNnYvv2 .ersCi17hvo_AFFOoJKx7 {
    color: rgba(63, 57, 31, 0.873);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
  }
  .oWon0UkDx0_lYPNnYvv2 .ersCi17hvo_AFFOoJKx7:hover {
    color: #fff;
  }
  .eYY6oPOBBw2QJkVdL2hH {
    background-color: #1e254a;
    color: ghostwhite;
    font-family: "Poppins", sans-serif;
    border: none;
    padding: 0.75rem 1.5rem;
    font-weight: 500;
    font-size: 1.1rem;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    border-radius: 5px;
    text-transform: uppercase;
  }
  .eYY6oPOBBw2QJkVdL2hH:hover {
    color: #1e254a;
    background-color: whitesmoke;
    transform: scale(1);
  }
}
@media (-webkit-min-device-pixel-ratio: 2) and (max-width: 1200px), (min-resolution: 192dpi) and (max-width: 1200px) {
  .fdvC6wJWb7N6Pdr98BXA,
  .oWon0UkDx0_lYPNnYvv2 {
    clip-path: polygon(75% 2%, 100% 0, 100% 100%, 79% 99%, 25% 100%, 0 99%, 0 0);
  }
}
@media (-webkit-min-device-pixel-ratio: 2) and (max-width: 992px), (min-resolution: 192dpi) and (max-width: 992px) {
  .fdvC6wJWb7N6Pdr98BXA,
  .oWon0UkDx0_lYPNnYvv2 {
    clip-path: polygon(75% 2%, 100% 0, 100% 100%, 79% 99%, 25% 100%, 0 99%, 0 0);
  }
}
@media (-webkit-min-device-pixel-ratio: 2) and (max-width: 768px), (min-resolution: 192dpi) and (max-width: 768px) {
  .fdvC6wJWb7N6Pdr98BXA,
  .oWon0UkDx0_lYPNnYvv2 {
    clip-path: polygon(75% 2%, 100% 0, 100% 100%, 79% 99%, 25% 100%, 0 99%, 0 0);
  }
}
@media (-webkit-min-device-pixel-ratio: 2) and (max-width: 576px), (min-resolution: 192dpi) and (max-width: 576px) {
  .fdvC6wJWb7N6Pdr98BXA {
    padding-top: 5rem;
    padding-bottom: 5rem;
    margin-bottom: -0.25rem;
  }
  .fdvC6wJWb7N6Pdr98BXA,
  .oWon0UkDx0_lYPNnYvv2 {
    clip-path: polygon(65% 0, 100% 3%, 100% 100%, 34% 95%, 0 100%, 0 0, 36% 6%);
    height: 30rem;
  }
  .oWon0UkDx0_lYPNnYvv2 {
    padding: 2rem 2rem;
    font-size: 0.8rem;
    margin: 0;
  }
}
@media screen and (-webkit-min-device-pixel-ratio: 2) and (max-width: 500px), screen and (min-resolution: 192dpi) and (max-width: 500px) {
  .fdvC6wJWb7N6Pdr98BXA {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MissionStatement/MissionStatement.module.scss"],"names":[],"mappings":"AAAA;EACI;IACI,kBAAA;IACA,2EAAA;IACA,yDAAA;IACA,6BAAA;IACA,sBAAA;IACA,2BAAA;IACA,kCAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;EACN;EAEE;IACI,2EAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,mBAAA;IACA,UAAA;EAAN;EAGE;IACI,8BAAA;IACA,qBAAA;IACA,gBAAA;IACA,2BAAA;EADN;EAIE;IACI,WAAA;EAFN;EAKE;IACI,yBAAA;IACA,iBAAA;IACA,kCAAA;IACA,YAAA;IACA,uBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,uDAAA;IACA,kBAAA;IACA,yBAAA;EAHN;EAME;IACI,cAAA;IACA,4BAAA;IACA,mBAAA;EAJN;AACF;AAMI;EACI;;IAEI,4EAAA;EAJV;AACF;AAOI;EACI;;IAEI,4EAAA;EALV;AACF;AAQI;EACI;;IAEI,4EAAA;EANV;AACF;AASI;EACI;IACI,iBAAA;IACA,oBAAA;IACA,uBAAA;EAPV;EAUM;;IAEI,2EAAA;IACA,aAAA;EARV;EAWM;IACI,kBAAA;IACA,iBAAA;IACA,SAAA;EATV;AACF;AAYI;EACI;IACE,yDAAA;IACA,sBAAA;EAVR;AACF","sourcesContent":["@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n    .MissionStatement {\n        position: relative;\n        clip-path: polygon(65% 0, 100% 3%, 100% 100%, 34% 95%, 0 100%, 0 0, 36% 6%);\n        background-image: url('/public/img/forester-film-edits-44.jpg');\n        background-attachment: scroll;\n        background-size: cover;\n        background-position: center;\n        font-family: \"Poppins\", sans-serif;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        margin-bottom: 5rem;\n        overflow: hidden;\n    }\n\n    .MissionStatementPara {\n        clip-path: polygon(65% 0, 100% 3%, 100% 100%, 34% 95%, 0 100%, 0 0, 36% 6%);\n        font-size: 1.2rem;\n        line-height: 1.6rem;\n        color: ghostwhite;\n        position: relative;\n        margin: 5rem;\n        padding: 10rem 2rem;\n        z-index: 2;\n    }\n\n    .MissionStatementPara .link {\n        color: rgba(63, 57, 31, 0.873);\n        text-decoration: none;\n        font-weight: 500;\n        transition: color 0.3s ease;\n    }\n\n    .MissionStatementPara .link:hover {\n        color: #fff;\n    }\n\n    .linkButton {\n        background-color: #1e254a;\n        color: ghostwhite;\n        font-family: \"Poppins\", sans-serif;\n        border: none;\n        padding: 0.75rem 1.5rem;\n        font-weight: 500;\n        font-size: 1.1rem;\n        cursor: pointer;\n        transition: background-color 0.3s ease, color 0.3s ease;\n        border-radius: 5px;\n        text-transform: uppercase;\n    }\n\n    .linkButton:hover {\n        color: #1e254a;\n        background-color: whitesmoke;\n        transform: scale(1);\n    }\n\n    @media (max-width: 1200px) {\n        .MissionStatement,\n        .MissionStatementPara {\n            clip-path: polygon(75% 2%, 100% 0, 100% 100%, 79% 99%, 25% 100%, 0 99%, 0 0);\n        }\n    }\n\n    @media (max-width: 992px) {\n        .MissionStatement,\n        .MissionStatementPara {\n            clip-path: polygon(75% 2%, 100% 0, 100% 100%, 79% 99%, 25% 100%, 0 99%, 0 0);\n        }\n    }\n\n    @media (max-width: 768px) {\n        .MissionStatement,\n        .MissionStatementPara {\n            clip-path: polygon(75% 2%, 100% 0, 100% 100%, 79% 99%, 25% 100%, 0 99%, 0 0);\n        }\n    }\n\n    @media (max-width: 576px) {\n        .MissionStatement {\n            padding-top: 5rem;\n            padding-bottom: 5rem;\n            margin-bottom: -.25rem;\n        }\n        \n        .MissionStatement,\n        .MissionStatementPara {\n            clip-path: polygon(65% 0, 100% 3%, 100% 100%, 34% 95%, 0 100%, 0 0, 36% 6%);\n            height: 30rem;\n        }\n\n        .MissionStatementPara {\n            padding: 2rem 2rem;\n            font-size: .8rem;\n            margin: 0;\n        }\n    }\n\n    @media screen and (max-width: 500px) {\n        .MissionStatement {\n          background-image: url('/public/img/forester-film-edits-44.jpg');\n          background-size: cover;\n        }\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MissionStatement": `fdvC6wJWb7N6Pdr98BXA`,
	"MissionStatementPara": `oWon0UkDx0_lYPNnYvv2`,
	"link": `ersCi17hvo_AFFOoJKx7`,
	"linkButton": `eYY6oPOBBw2QJkVdL2hH`
};
export default ___CSS_LOADER_EXPORT___;
